import {
	API_POST_PAYMENT,
	API_GET_FOLDER_IS_PAID,
	API_POST_PAY_LOG,
	API_GET_FOLDER_PAYMENT_CANCEL,
	API_GET_TERMINALS,
	API_GET_PAYMENTS_FOR_USER,
	API_POST_FOLDER_PAYMENT_REF,
	API_GET_PAYMENTS_FOR_EXCELL,
	API_GET_CASING_PAYMENT_CANCEL,
} from "actions/payment";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_POST_PAYMENT]: {
		default: () => `payments`,
		v2: () => `/payments`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_FOLDER_IS_PAID]: {
		default: (folderId) => `payments/${folderId}/isPaid`,
		v2: (folderId) => `/payments/${folderId}/isPaid`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_FOLDER_PAYMENT_CANCEL]: {
		default: (folderId, paymentId) => `payments/${folderId}/cancel/${paymentId}`,
		v2: (folderId, paymentId) => `/payments/${folderId}/cancel/${paymentId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CASING_PAYMENT_CANCEL]: {
		default: (casingId, paymentId) => `payments/casing/${casingId}/cancel/${paymentId}`,
		v2: (casingId, paymentId) => `/payments/casing/${casingId}/cancel/${paymentId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_FOLDER_PAYMENT_REF]: {
		default: () => `payments/ref`,
		v2: () => `/payments/ref`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_PAY_LOG]: {
		default: () => `payments/pay/log`,
		v2: () => `/payments/pay/log`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_TERMINALS]: {
		default: (centerId) => `servipayTerminals/${centerId || "no-center"}`,
		v2: (centerId) => `/servipayTerminals/${centerId || "no-center"}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_PAYMENTS_FOR_USER]: {
		default: () => `payments/user`,
		v2: () => `/payments/user`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_PAYMENTS_FOR_EXCELL]: {
		default: () => `payments/export`,
		v2: () => `/payments/export`,
		currentClient: DEFAULT_CLIENT,
	},
};

export function addPayment(
	type,
	folderId,
	transaction_id,
	price,
	success,
	invoice_reference,
	repartition,
	reason,
	patient_external_id = null,
	patient_name = null,
	center_id = null
) {
	const version = getVersion(API_POST_PAYMENT);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_POST_PAYMENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: {
					type,
					folderId,
					transaction_id,
					price,
					success,
					invoice_reference,
					repartition,
					reason,
					patient_external_id,
					patient_name,
					center_id,
				},
			},
		},
	};
}

export function folderIsPaid(folderId) {
	const version = getVersion(API_GET_FOLDER_IS_PAID);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_GET_FOLDER_IS_PAID,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "get",
			},
		},
	};
}
export function folderPaymentCancel(folderId, paiementId) {
	const version = getVersion(API_GET_FOLDER_PAYMENT_CANCEL);
	const url = typeof version.path === 'function' ? version.path(folderId, paiementId) : version.path;
	return {
		type: API_GET_FOLDER_PAYMENT_CANCEL,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "get",
			},
		},
	};
}
export function casingPaymentCancel(casingId, paiementId) {
	const version = getVersion(API_GET_CASING_PAYMENT_CANCEL);
	const url = typeof version.path === 'function' ? version.path(casingId, paiementId) : version.path;
	return {
		type: API_GET_CASING_PAYMENT_CANCEL,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "get",
			},
		},
	};
}

export function folderPaymentRef(folderId, paiementId, reference, partition) {
	const version = getVersion(API_POST_FOLDER_PAYMENT_REF);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_POST_FOLDER_PAYMENT_REF,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: {
					paiementId,
					folderId,
					reference,
					partition,
				},
			},
		},
	};
}

export function payLog(message, tid, amount, communication) {
	const version = getVersion(API_POST_PAY_LOG);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_POST_PAY_LOG,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "post",
				data: {
					message,
					tid,
					amount,
					communication,
				},
			},
		},
	};
}

export function getTerminalsByCenter(centerId) {
	const version = getVersion(API_GET_TERMINALS);
	const url = typeof version.path === 'function' ? version.path(centerId) : version.path;
	return {
		type: API_GET_TERMINALS,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "get",
			},
		},
	};
}

export function getPaymentsForUser(
	startDate = null,
	endDate = null,
	page = 1,
	size = 200,
	search = "",
	center = null,
	box = "",
	user_id = null,
	mode = null
) {
	const version = getVersion(API_GET_PAYMENTS_FOR_USER);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_PAYMENTS_FOR_USER,
		payload: {
			client: version.currentClient,
			request: {
				url,
				params: { startDate, endDate, page, size, search, center, box, user_id, mode },
			},
		},
	};
}

export function getAdminPaymentsForUser(
	startDate = null,
	endDate = null,
	page = 1,
	size = 200,
	search = "",
	center = null,
	box = "",
	user_id = null,
	mode = null
) {
	const version = getVersion(API_GET_PAYMENTS_FOR_USER);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_PAYMENTS_FOR_USER,
		payload: {
			client: version.currentClient,
			request: {
				url: `admin/payments/user`,
				params: { startDate, endDate, page, size, search, center, box, user_id, mode },
			},
		},
	};
}
export function exportPayments(
	startDate = null,
	endDate = null,
	page = 1,
	size = 20,
	search = "",
	centers = [],
	box = "",
	user_id = null,
	mode = null
) {
	const version = getVersion(API_GET_PAYMENTS_FOR_EXCELL);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_PAYMENTS_FOR_EXCELL,
		payload: {
			client: version.currentClient,
			request: {
				url,
				params: { startDate, endDate, page, size, search, centers, box, user_id, mode },
			},
		},
	};
}
